/** @format */

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { FormikProps } from 'formik';
import * as React from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectConstants } from './Api/constantSlice';
import { DropdownDto } from './Api/Models';
import { ErrorBox } from '../custom/ErrorBox';

interface Props {
  formik: FormikProps<any>;
}
export default function Universities({ formik }: Props) {
  const selConst = useAppSelector(selectConstants);
  return (
    <>
      {selConst.constantState.universities && (
        <>
          <FormControl fullWidth>
            <InputLabel
              error={
                formik.touched.institutionId &&
                Boolean(formik.errors.institutionId)
              }
              id='demo-select-small'>
              University Name
            </InputLabel>
            <Select
              name='institutionId'
              labelId='demo-select-small'
              id='demo-select-small'
              value={formik.values.institutionId}
              label='University Name'
              onBlur={formik.handleBlur}
              onChange={(e) => {
                const raw = e.target.value;
                const id =
                  typeof raw === 'number'
                    ? raw
                    : parseInt(String(raw), 10) || 0;
                formik.setFieldValue('institutionId', id);
                formik.setFieldValue('yearOfStudyId', 0);
              }}
              error={
                formik.touched.institutionId &&
                Boolean(formik.errors.institutionId)
              }>
              <MenuItem value={0} disabled>
                Select University Name
              </MenuItem>
              {selConst.constantState.universities
                .filter((s) => s.id !== 21)
                .map((data: DropdownDto, key: number) => {
                  return (
                    <MenuItem key={key} value={data.id}>
                      {data.description}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>

            <ErrorBox>
            {formik.touched.institutionId &&
            (formik.errors.institutionId as React.ReactNode)}
                                                  </ErrorBox>

          
        </>
      )}
    </>
  );
}
